import React from 'react'

const Arrow = props => (
  <svg viewBox="0 0 13 7" {...props}>
    <g>
      <path
        d="M11.93,0,5.53,6,6.6,7,13,1,11.93,0ZM0,1,6.4,7,7.47,6,1.07,0,0,1Z"
        //style="fill:#e2e5e7"
      />
    </g>
  </svg>
)

export default Arrow
